import { SITE, siteUrl, type Lang } from '@/lib/site'

export function organizationSchema(lang: Lang) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${SITE.hosts[lang]}#organization`,
    name: SITE.name,
    legalName: SITE.name,
    url: SITE.hosts[lang],
    logo: `${SITE.hosts[lang]}/favicon.png`,
    description:
      lang === 'pt-BR'
        ? 'Bravic — Enterprise Agent Platform. Do diagnóstico estratégico à operação contínua de agentes de IA em produção, com Agent Engineer embarcado.'
        : 'Bravic — Enterprise Agent Platform. From strategic assessment to continuous operation of production AI agents, with an embedded Agent Engineer.',
    sameAs: SITE.socials,
    contactPoint: [
      {
        '@type': 'ContactPoint',
        email: SITE.contactEmail[lang],
        contactType: 'sales',
        availableLanguage: ['Portuguese', 'English'],
      },
    ],
  }
}

export function websiteSchema(lang: Lang) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE.hosts[lang]}#website`,
    name: SITE.name,
    url: SITE.hosts[lang],
    inLanguage: lang,
    publisher: { '@id': `${SITE.hosts[lang]}#organization` },
  }
}

export function breadcrumbSchema(lang: Lang, items: { name: string; path: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: siteUrl(lang, item.path),
    })),
  }
}

interface ServiceArgs {
  name: string
  description: string
  path: string
}

export function serviceSchema(lang: Lang, args: ServiceArgs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: args.name,
    description: args.description,
    url: siteUrl(lang, args.path),
    provider: { '@id': `${SITE.hosts[lang]}#organization` },
    areaServed: lang === 'pt-BR' ? 'BR' : 'Worldwide',
  }
}

interface ArticleArgs {
  headline: string
  description: string
  path: string
  image?: string
  datePublished?: string
}

export function articleSchema(lang: Lang, args: ArticleArgs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: args.headline,
    description: args.description,
    inLanguage: lang,
    mainEntityOfPage: siteUrl(lang, args.path),
    url: siteUrl(lang, args.path),
    image: args.image,
    datePublished: args.datePublished,
    publisher: { '@id': `${SITE.hosts[lang]}#organization` },
    author: { '@id': `${SITE.hosts[lang]}#organization` },
  }
}

interface CaseArgs {
  name: string
  description: string
  path: string
  image?: string
  client: string
}

export function caseStudySchema(lang: Lang, args: CaseArgs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    '@id': `${siteUrl(lang, args.path)}#case`,
    headline: args.name,
    description: args.description,
    inLanguage: lang,
    url: siteUrl(lang, args.path),
    image: args.image,
    about: {
      '@type': 'Organization',
      name: args.client,
    },
    publisher: { '@id': `${SITE.hosts[lang]}#organization` },
  }
}
